var path = '/templates/projects/views/directives/project_apikey_menu.html';
var html = "<li ng-if=Project.currentProject><span style=\"color: #fff\"><i class=\"fa fa-product-hunt\"></i> <span style=\"user-select: all; cursor: pointer;\">{{ Project.currentProject.apikey }}</span></span></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects/views/directives/project_apikey_menu.html
// module id = 1606
// module chunks = 0